import { render } from "./descubre.vue?vue&type=template&id=fe3b1064&scoped=true"
import script from "./descubre.vue?vue&type=script&lang=js"
export * from "./descubre.vue?vue&type=script&lang=js"

import "./descubre.vue?vue&type=style&index=0&id=fe3b1064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3b1064"]])

export default __exports__